import React, { Component } from "react";

export class SectionContainer extends Component {

    render() {
        return (
            <div className={"section-container " + this.props.className}>
                <div className={this.props.titleTextClassName ? this.props.titleTextClassName : "section-container-top"}>
                    <span className={this.props.titleTextClassName ? this.props.titleTextClassName : "section-container-title"}>
                        {this.props.titleText ? this.props.titleText : ""}
                    </span>

                    <span className={this.props.textRightClassName? this.props.textRightClassName : "section-container-text-right"}>
                        {this.props.textRight ? this.props.textRight : ""}
                    </span>
                    
                </div>
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/features/common/SectionContainer.js